import { render, staticRenderFns } from "./SelectLocalidades.vue?vue&type=template&id=3a56ef50"
import script from "./SelectLocalidades.vue?vue&type=script&lang=js"
export * from "./SelectLocalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports